import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/dotecApi";

const PRIVACY_URL = `${process.env.REACT_APP_BACKEND_URL}/api/privacy-policy`;

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 bg-slate-900 text-slate-300"
    >
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt="Dotec EW-PDF"
                className="h-10 w-10 rounded-xl object-cover"
              />
              <span className="font-display text-xl font-extrabold tracking-tight text-white">
                Dotec <span className="text-emerald-400">EW-PDF</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Convertitore professionale PDF in Excel e Word con OCR ibrido e
              intelligenza artificiale. Anche scansioni e fotografie.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <div>
              <h4 className="font-display text-sm font-bold text-white">
                Strumenti
              </h4>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/pdf-excel">
                    PDF → Excel
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/pdf-word">
                    PDF → Word
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/immagine-pdf">
                    Immagine → PDF
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/modifica-pdf">
                    Modifica PDF
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/comprimi-pdf">
                    Comprimi PDF
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/analisi-excel">
                    Analisi Excel
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-display text-sm font-bold text-white">
                Legale e Risorse
              </h4>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/blog" data-testid="footer-blog-link">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/guide" data-testid="footer-guides-link">
                    Guide e Tutorial
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/guide/evoluzione-ocr-ai">
                    L'evoluzione dell'OCR
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/guide/pdf-excel-contabilita">
                    PDF in Excel per la contabilità
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/guide/firma-digitale-pdf">
                    Guida alla firma digitale
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/guide/privacy-pennello-bianchetto">
                    Privacy e pennello bianchetto
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/guide/vantaggi-formato-word">
                    I vantaggi del formato Word
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/glossario-pdf" data-testid="footer-glossary-link">
                    Glossario PDF
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 transition-colors hover:text-emerald-400" to="/faq" data-testid="footer-faq-link">
                    Domande Frequenti (FAQ)
                  </Link>
                </li>
                <li>
                  <a
                    href={PRIVACY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-privacy-link"
                    className="text-slate-400 transition-colors hover:text-emerald-400"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-display text-sm font-bold text-white">
                Contatti
              </h4>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li className="text-slate-400">dotecexpdf@gmail.com</li>
                <li className="text-slate-400">{BRAND.domain}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-slate-800 pt-6 text-xs text-slate-500 sm:flex-row">
          <p>
            © {year} Dotec EW-PDF. Tutti i diritti riservati.
          </p>
          <p>Elaborazione sicura • File eliminati dopo la conversione</p>
        </div>
      </div>
    </footer>
  );
};
